/* Opens an agent's Tasks from anywhere a component can't navigate itself (one that renders
   outside the router too, in stories and tests). The app listens in `App.tsx`. */
export const OPEN_TASKS = "open-tasks";

export const openTasks = (agentId: string) =>
  window.dispatchEvent(new CustomEvent(OPEN_TASKS, { detail: agentId }));
